<template>
	<div v-show="show" style="width: 100%;">

		<el-table :stripe="stripe" :border="isborder" :style="tableStyle" :id="tableId" :data="list"
			:height="tableheight" :header-cell-style="cellstyle" :row-style="rowstyle" @row-click="toDetails"
			@selection-change="handleSelectionChange" ref="multipleTable" :row-class-name="tableRowClassName">
			<slot name="body"></slot>
			<template slot="empty">
				<div class="empty_box FlexColumn">
					<img src="https://scrm.51kuaiding.com/scrm/hktxcx/bulletinboard/empty_img.png" alt="">
					<div class="empty_tit">
						没有相关数据哦～
					</div>
				</div>
			</template>
		</el-table>
		<!--  -->
		<template v-if="botshow">
			<div class="table_bottom FlexBetween " :style="botClass">
				<!--  -->
				<div class="tleft Flexalign">
					<!--  -->
					<div class="t_checkbox" v-if="ischecks">
						<el-checkbox :indeterminate="isIndeterminate" v-model="allchecked"
							@change="fn_checkAll"></el-checkbox>
					</div>
					<!--  -->
					<slot name="tabtns"></slot>
				</div>
				<!--  -->
				<!--  -->
				<div class="tright Flexalign">
					<template v-if="ispagin">
						<el-pagination background layout="total,sizes, prev, pager, next" prev-text="上一页"
							next-text="下一页" :page-sizes="pagesizes" :page-size.sync="tab_pagesize"
							:current-page.sync="tab_page" :pager-count='5' :total="tab_total"
							@size-change="type_modify_page" @current-change="type_switch_page">
						</el-pagination>


					</template>
				</div>
				<!--  -->
			</div>
		</template>
		<!--  -->

	</div>
</template>

<script>
	var that
	export default {

		name: "tabcontainer",
		props: {

			tableId: {
				type: String,
				default: 'exportTab',
			},
			botClass: {
				type: String,
				default: 'padding: 10px 0',
			},
			tableStyle: {
				type: String,
				default: 'width: 99%;margin: 0 auto;',
			},

			// 是否显示斑马纹
			stripe: {
				type: Boolean,
				default: false,
			},
			// 是否显示
			show: {
				type: Boolean,
				default: true,
			},
			// 是否有边框
			isborder: {
				type: Boolean,
				default: false,
			},
			// 是否显示底部
			botshow: {
				type: Boolean,
				default: true,
			},


			// 是否多选
			ischecks: {
				type: Boolean,
				default: true,
			},
			// 是否显示分页
			ispagin: {
				type: Boolean,
				default: true,
			},
			// 

			// 页码 
			pagesize: {
				type: Number,
				default: 0,
			},
			page: {
				type: Number,
				default: 1,
			},
			total: {
				type: Number,
				default: 0,
			},
			// 
			// 表格高度
			surplus: {
				type: Number,
				default: 0,
			},
			pagesizes: {
				type: Array,
				default: () => {
					return [20, 50, 100, 300, 500, 1000]
				},
			},

			// 表格数据
			list: {
				type: Array,
				default: () => {
					return []
				},
			},

			// 表格样式
			cellstyle: {
				type: Object,
				default: () => {
					return {
						background: 'rgb(249,249,249)',
						height: '42px',
					}
				},
			},
			rowstyle: {
				type: Object,
				default: () => {
					return {
						height: '42px',
					}
				},
			},
			// 

		},
		data() {
			return {
				// surplus
				tableheight: '',
				check_list: [],
				// 全选
				allchecked: false,
				isIndeterminate: false,

				tab_pagesize: 50,
				tab_page: 1,
				tab_total: 0,
			}
		},

		created() {
			if (this.surplus) {
				this.tableheight = this.surplus
			}
			that = this
			window.addEventListener('resize', that.fn_mountEch)
		},
		watch: {
			'$store.state.surplus'(newVal,oldVal){
				//对数据执行操作
				console.log(newVal,oldVal)
				this.tableheight = newVal
			},
			surplus(){
				this.tableheight = this.surplus
			},
			pagesize() {
				this.tab_pagesize = this.pagesize
			},
			page() {
				this.tab_page = this.page
			},
			total() {
				this.tab_total = this.total
			},
			list(){
			},
			// 多选框
			check_list() {
				if (this.list) {
					let len1 = this.check_list.length
					let len2 = this.list.length
					if (len2 === len1) {
						this.isIndeterminate = false
						this.allchecked = true
					} else {
						this.allchecked = false
						this.isIndeterminate = true
					}
					if (len1 == 0) {
						this.allchecked = false
						this.isIndeterminate = false
					}
				}
			},
		},
		methods: {
			fn_mountEch(){
				// let hres = 0
				// if(window.innerWidth < 1161) {
				// 	hres = (window.innerHeight - 332)
				// }
				// else {
				// 	hres = (window.innerHeight - 312)
				// }
				
						
				that.$store.commit('resizeSurplus')
				that.tableheight = that.$store.state.surplus
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex === 1) {
					return 'warning-row';
				} else if (rowIndex === 3) {
					return 'success-row';
				}
				return '';
			},
			// 底部全选
			fn_checkAll(e) {
				if (this.allchecked === true) {
					this.$refs.multipleTable.toggleAllSelection();
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			
			fnclearSel() {
				this.$refs.multipleTable.clearSelection();
			},
			// 勾选表格
			handleSelectionChange(val) {
				this.check_list = val
				this.$emit('retucheck', {
					val
				})
			},

			// 点击表格某一行 
			toDetails(row) {
				this.$emit('returow', {
					row
				})
			},

			// 切换页码
			type_modify_page(val) { // pagesize 

				// this.$parent.modify_pagesize();
				this.$emit('changesize', {
					val
				})
			},
			type_switch_page(val) { // page
				// this.$parent.switch_page();
				this.$emit('changepage', {
					val
				})
			},
			// methids end
		}
	}
</script>

<style scoped lang="scss">
	// /deep/ .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
	//     width: 6px;
	//     border-radius: 30px;
	// }

	// /deep/ .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
	//     background-color: #F6F8FB;
	//     border-radius: 30px;
	// }

	// /deep/ .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
	//     background: #c1c1c1;
	//     border-radius: 30px;
	// }
	/deep/ .el-table .el-table__cell{
		padding: 0;
	}
	.table_box {
		width: 100%;
		background-color: #fff;

		// 
		/deep/ .el-table {
			width: 100%;

		}

		.table_bottom.botsolid {
			border-top: solid 1px #ebeef5;
		}

		.table_bottom {
			width: 99%;
			margin: 0 auto;
			position: sticky;
			bottom: 0;
			z-index: 100;

			background: #fff;

			.tleft {
				/deep/ .el-button {
					padding: 0 14px !important;
					height: 32px;
					padding: 0;
					color: #fff;
					border: none;
				}

				/deep/ .el-button.color1 {
					background: var(--themeColors);
				}

				/deep/ .el-button.color2 {
					background: rgba(66, 172, 78, 1);
				}

				.t_checkbox {
					padding-left: 16px;
					margin-right: 16px;
				}
			}

			.tright {}
		}
	}


	/deep/ .el-table th.gutter {
		background: #f9f9f9;
	}

	//
	.empty_box {
		img {
			width: 145px;
		}

		.empty_tit {
			color: rgba(0, 0, 0, .65);
			font-size: 13px;
		}
	}
</style>